import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "gm_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login") && !err.config?.url?.includes("/auth/me")) {
      setToken(null);
      window.dispatchEvent(new Event("gm-logout"));
    }
    return Promise.reject(err);
  }
);

export const errorText = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const absUrl = (rel) => (rel ? `${BACKEND_URL}${rel}` : null);
export const authedUrl = (path) => `${API}${path}?token=${encodeURIComponent(getToken() || "")}`;

export const parseEpisode = (filename, index = 0) => {
  const base = filename.replace(/\.[^.]+$/, "");
  let m = base.match(/S(\d{1,2})\s*[-_. ]?\s*E(\d{1,3})/i);
  if (m) return `S${m[1].padStart(2, "0")}E${m[2].padStart(2, "0")}`;
  m = base.match(/\b(?:EP|Ep|Episode|E)[\s_.-]*(\d{1,3})\b/i);
  if (m) return `EP${m[1].padStart(2, "0")}`;
  m = base.match(/(?:^|[\s_-])(\d{1,3})(?:$|[\s_-])/);
  if (m) return `EP${m[1].padStart(2, "0")}`;
  return `EP${String(index + 1).padStart(2, "0")}`;
};

export const STEM_META = {
  original: { label: "Original Mix", short: "ORIG", color: "#94A3B8" },
  dialogue: { label: "Dialogue", short: "DX", color: "#38BDF8" },
  music: { label: "Music", short: "MX", color: "#A855F7" },
  effects: { label: "Effects / Foley / Ambience", short: "FX", color: "#F59E0B" },
  me: { label: "M&E (Music + Effects)", short: "M&E", color: "#10B981" },
};
export const STEM_ORDER = ["original", "dialogue", "music", "effects", "me"];

export const PRESET_LABELS = {
  DME: "DME — Dialogue / Music / Effects + M&E",
  ME: "M&E — Music + Effects (dialogue removed)",
  EFFECTS: "Effects only",
  MUSIC: "Music only",
  DIALOGUE: "Dialogue only",
};
